/* Lazy-activate hero <video> elements marked .js-lazy-video.
   Until activated, the <source> tags use data-src so the browser never fetches
   the video. The poster image renders immediately. We swap data-src→src and
   call load()/play() when the video scrolls into the viewport, or on first
   user interaction as a fallback. */
(function () {
  if (typeof document === 'undefined') return;

  function activate(video) {
    if (video.dataset.lazyVideoActivated) return;
    video.dataset.lazyVideoActivated = '1';
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      var s = sources[i];
      s.src = s.getAttribute('data-src');
      s.removeAttribute('data-src');
    }
    try { video.load(); } catch (e) {}
    var playPromise = video.play && video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () { /* autoplay may be blocked; that's fine */ });
    }
  }

  function init() {
    var videos = document.querySelectorAll('video.js-lazy-video');
    if (!videos.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activate(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });
      videos.forEach(function (v) { io.observe(v); });
    } else {
      // No IntersectionObserver — activate on first user interaction
      var fallback = function () {
        videos.forEach(activate);
        ['scroll', 'touchstart', 'mousemove'].forEach(function (e) {
          window.removeEventListener(e, fallback, { passive: true });
        });
      };
      ['scroll', 'touchstart', 'mousemove'].forEach(function (e) {
        window.addEventListener(e, fallback, { passive: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
